import React, { useState } from 'react'
import bg from '../images/banner.webp';
import { useDispatch, useSelector } from 'react-redux';
import ContactModal from './ContactModal';
import { setToggleTrue } from '../redux/slice/changeState';
import { useMediaQuery } from 'react-responsive';
import ToggleMenu from './ToggleMenu';
import img from '../images/logo_white.webp';
import { Row, Col } from 'react-bootstrap';

const MobileBanner = () => {
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 991px)' });
  const dispatch = useDispatch()
  const toggle = useSelector((state) => state.toggle);

  return (
    <>
      <div className='text-center banner' style={{ backgroundImage: `url(${bg})` }}>
        <ToggleMenu />

        <div className='banner-title'>
          <img src="/mLogo.png" alt="IRA Miracle Logo" />
        </div>
        <div className='banner-discption'>
          <h1 className='text-uppercase' >Ready-to-Move IN Luxury 3 BHK Apartments in Kollur</h1>
          <p className='text-capitalize'>Luxury living in Kollur, Hyderabad with premium amenities, spacious designs and unbeatable pricing starting at ₹6,499/sq. ft.</p>
          <div className='btns'>
            <button className='visit-btn' onClick={() => dispatch(setToggleTrue())}>Book a Visit</button>
            <button className='explore-btn mb-5'><a href='https://wa.api-whatsapp.in/ehbv4C' target="_blank" rel="noreferrer">Chat on whatsApp</a></button>
            <div className='container px-5 ' style={{
              maxWidth: "400px"
            }}>
              <Row className='border border-white'>
                <Col lg={12} md={12} xs={12} className='border-bottom  py-1'>
                  <p className="small-text">Layout/Building/Permission No.</p>
                  <p className='large-text'>File No. 036703/SKP/R1/U6/HMDA/19062020</p>
                </Col>

                <Col lg={12} md={12} xs={12} className='  py-1'>
                  <p className='large-text'>
                    TG RERA Registration No. <span>P01100002880</span>
                  </p>
                  <p className="small-text">
                    Website: rera.telangana.gov.in
                  </p>
                </Col>


              </Row>


            </div>
          </div>
        </div>

      </div>
      {
        toggle.hastoggle && <ContactModal />
      }

    </>
  )
}

export default MobileBanner
